export var CalloutContentStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects;
    return {
        root: {
            borderRadius: effects.roundedCorner2,
            borderWidth: 0,
            boxShadow: effects.elevation16,
        },
        beakCurtain: {
            borderRadius: effects.roundedCorner2,
        },
        calloutMain: {
            borderRadius: effects.roundedCorner2,
        },
    };
};
//# sourceMappingURL=Callout.styles.js.map